import { Parameter } from "../models/Parameter";
import { PaginatedList } from "../helpers/PaginatedList";
import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";
import { CheckListModelTaskDTO } from "../models/CheckListModelTask/CheckListModelTaskDTO";
import { CreateCheckListModelTaskDTO } from "../models/CheckListModelTask/CreateCheckListModelTaskDTO";
import { EditCheckListModelTaskDTO } from "../models/CheckListModelTask/EditCheckListModelTaskDTO";

export class CheckListModelTaskService {
  async GetAllTasks(
    checkListModelId: number,
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<CheckListModelTaskDTO>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/CheckListModelTask/GetAllTasks?checkListModelId=${checkListModelId}`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<CheckListModelTaskDTO>(
        false,
        "Erro ao obter a informação sobre as tasks do Checklist",
        "",
        [],
        0
      );
    }
  }
  
  async Create(
    createCheckListModelTask: CreateCheckListModelTaskDTO
  ): Promise<MessagingHelper<number>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/CheckListModelTask/Create`,
        {
          ...createCheckListModelTask,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
  
      return response.data;
    } catch (error) {
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para criar a task do modelo de checklist",
        0
      );
    }
  }

  async Edit(
      checklistTaskUpdate: EditCheckListModelTaskDTO
    ): Promise<MessagingHelper<null>> {
      try {
        const response = await APIService.Axios().post(
          `${APIService.GetURL()}/CheckListModelTask/Edit`,
          { ...checklistTaskUpdate },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + APIService.GetToken(),
            },
          }
        );
        return response.data;
      } catch (error) {
        return new MessagingHelper<null>(
          false,
          "Erro ao ligar ao servidor para atualizar a tarefa do modelo de checklist",
          null
        );
      }
    }

    async GetById(id: number): Promise<MessagingHelper<CheckListModelTaskDTO | null>> {
        try {
          const response = await APIService.Axios().get(
            `${APIService.GetURL()}/CheckListModelTask/${id}`,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<null>(
            false,
            "Erro ao obter a tarefa do modelo de checklist",
            null
          );
        }
      }

      async Delete(id: number): Promise<MessagingHelper<null>> {
    try {
        const response = await APIService.Axios().put(
            `${APIService.GetURL()}/CheckListModelTask/Delete?id=${id}`,
            {}, // corpo vazio como definiste
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        return new MessagingHelper<null>(
            false,
            "Erro ao ligar ao servidor para eliminar a Tarefa do Modelo de Checklist",
            null
        );
    }
}
  
}
